import {
  hasMakeRequestBridge,
  ingestData,
  isMobile,
  makeRequest,
} from "../../bridges/BridgeServices";
import { bridgePromiseWrapper } from "../../bridges/BridgePromise/bridgePromise";
import { setTransactionsLoading } from "../../store/slices/recentActivity/recentActivity.setters";
import {
  API_ENUMS,
  API_METHODS,
} from "../../bridges/bridgeConstants";
import { createApiData } from "../service.helper";
import { EVENTS } from "../../utils/constants";
import { AUTH_STATUS_URL } from "./authStatus.url";

const fetchAuthStatus = async () => {
  try {
    if (isMobile() && !hasMakeRequestBridge()) return;

    const apiData = () => {
      return createApiData(
        API_METHODS.POST,
        AUTH_STATUS_URL
      );
    };

    const resp = await bridgePromiseWrapper(
      makeRequest(
        {
          ...apiData(),
        },
        API_ENUMS.AUTH_STATUS_URL
      )
    );
  } catch (err) {
    ingestData({
      name: EVENTS.FETCH_AUTH_STATUS_ERROR,
    });
  }
};

export default fetchAuthStatus;
